<template>
    <component :is="template">
        <div>
            <v-btn block rounded color="white" @click="$refs.modal.open()">열기</v-btn>
            <modal ref="modal" />
        </div>
    </component>
</template>

<script>
import Modal from "@/components/client/event/modal.vue";
export default {
    components: {
        Modal,
    },
    data() {
        return {};
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.main}`);
        },
    },
};
</script>

<style scoped></style>
